import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { Button } from 'react-bootstrap'
import * as project from '../../utils/project'
import style from './styles.less'
import classNames from 'classnames'

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            error: false
        }
    }

    loginForm(e) {
        var self = this
        if (e.type === 'click' || e.keyCode === 13) {
            var username = self.refs.inputUsername.value ? self.refs.inputUsername.value.toLowerCase() : ''
            var password = self.refs.inputPassword.value
            self.setState({ loading: true, error: false })
            self.props.actions.userLogin({
                username: username,
                password: password
            }).then(function(result) {
                self.setState({ loading: false, error: result.error })
            })
        }
    }

    render() {
        var self = this
        return (
            <div className={style.container}>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
                            <div className={style.logo}></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <h3 className={style.title}>{ project.title }</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
                            <form role="form">
                                <fieldset className={style.fieldset}>
                                    <div className="form-group">
                                        <input type="email" ref="inputUsername" onKeyDown={self.loginForm.bind(self)} className="form-control" placeholder="Usuario"></input>
                                    </div>
                                    <div className="form-group">
                                        <input type="password" ref="inputPassword" onKeyDown={self.loginForm.bind(self)} className="form-control" placeholder="Contraseña" ></input>
                                    </div>
                                </fieldset>
                                <Button className={classNames(style.button, 'btn btn-lg btn-block')} type="button" onClick={self.loginForm.bind(self)} disabled={ self.state.loading }>{ self.state.loading ? 'Ingresando...' : 'Ingresar' }</Button>
                                {self.state.error && <div className={style.error}>Usuario y/o contraseña incorrectos</div>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isReady: state.isReady,
        profile: state.profile
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Login)



// WEBPACK FOOTER //
// ./components/Login/index.js